<template>
    <div>
        <HeaderStock header="คลัง" :img_header="header_image" link_back="addlotout" />
        <MenuStockList/>
        <AddLotoutSummarizeList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/icon-stock.png'
import HeaderStock from '@/components/menuadmin/stock/stockheader/HeaderStock.vue'
import MenuStockList from '@/components/menuadmin/stock/stocklist/MenuStockList.vue'
import AddLotoutSummarizeList from '@/components/menuadmin/stock/stocklist/AddLotoutSummarizeList.vue'

export default {
    name:'addLotoutSummarize',
    components:{
        HeaderStock,
        MenuStockList,
        AddLotoutSummarizeList,
    },
    data(){
        return{
            header_image:HeaderImage
        }
    }
}
</script>